// Where the Uptrack mobile apps and their promo video live, said once for every page.
//
// Set a value to show it. The homepage section (components/home/mobile-apps.tsx) draws only what is set,
// so it stays hidden until there is something real to show: never a dead store link.
//
//  - promoVideoId: the YouTube id of the app preview video (the same one used on the Google Play listing).
//                  The page plays our own file (MOBILE_APP_VIDEO_URL); the id only decides that the preview shows.
//  - androidUrl:   the public Google Play page. Set it only once the app is published there
//                  (https://play.google.com/store/apps/details?id=app.uptrack.mobile returns 404 until then).
//  - iosUrl:       the public App Store page, once the iOS app is released.

export type MobileApp = {
  promoVideoId: string | null
  androidUrl: string | null
  iosUrl: string | null
}

export const MOBILE_APP: MobileApp = {
  promoVideoId: 'c84ViPGLqIM',
  androidUrl: null,
  iosUrl: null,
}

/** The poster shown before the video loads. A local file, so the page loads no video until play. */
export const MOBILE_APP_POSTER = '/promo/uptrack-app-poster.jpg'

/**
 * The app preview video file (720p MP4, 44.6 s, about 1.8 MB). It lives in the R2 bucket `uptrack-web-media`,
 * served at `video.uptrack.app`. The name carries a version: upload a new file as `-v2` and change it here,
 * because the file is cached for a year.
 */
export const MOBILE_APP_VIDEO_URL = 'https://video.uptrack.app/app-preview-v1-720.mp4'
